module.exports = __webpack_public_path__ + "static/media/ic_edit.48d1c1f7.svg";